import {createFeature, createReducer, on} from "@ngrx/store";
import {APP_CONSTANTS} from "../../app.constants";
import {CustomerModel, FilterInterface, PaginationInfoInterface} from "../../interfaces";
import * as CustomerActions from "../actions/customers.actions";

export const customersFeatureKey = "Customers";

export interface State {
  customerItems: Array<CustomerModel>;
  customerItemsPaginated: Array<CustomerModel>;
  customerFilters: FilterInterface;
  customerPaginationInfo: PaginationInfoInterface;
}

export const initialState: State = {
  customerItems: [],
  customerItemsPaginated: [],
  customerFilters: {
    limit: APP_CONSTANTS.PAGINATION_PAGE_SIZE,
    offset: 0
  },
  customerPaginationInfo: {
    from: 0,
    to: 0,
    totalResults: 0,
    currentPage: 0,
    totalPages: 1
  }
};

export const customersFeature = createFeature({
  name: customersFeatureKey,
  reducer: createReducer(
    initialState,
    on(
      CustomerActions.addCustomer,
      (state: State, {customer}): State => ({
        ...state,
        customerItems: [...state.customerItems, customer]
      })
    ),
    on(CustomerActions.addCustomers, (state: State, {customers}): State => {
      const newCustomers = [...state.customerItems, ...customers];
      return {
        ...state,
        customerItems: newCustomers
      };
    }),
    on(CustomerActions.updateCustomer, (state: State, {customer}): State => {
      const customers = state.customerItems.map(item => (item.name === customer.name ? customer : item));
      return {
        ...state,
        customerItems: customers
      };
    }),
    on(
      CustomerActions.setCustomers,
      (state: State, {customers}): State => ({
        ...state,
        customerItems: customers
      })
    ),
    on(
      CustomerActions.setPaginatedCustomers,
      (state: State, {customers}): State => ({
        ...state,
        customerItemsPaginated: customers
      })
    ),
    on(
      CustomerActions.setCustomersPaginationInfo,
      (state: State, {paginationInfo}): State => ({...state, customerPaginationInfo: paginationInfo})
    ),
    on(
      CustomerActions.gotoCustomersPage,
      (state: State, {page}): State => ({
        ...state,
        customerFilters: {...state.customerFilters, offset: state.customerFilters.limit * (page - 1)},
        customerPaginationInfo: {...state.customerPaginationInfo, currentPage: page}
      })
    ),
    on(CustomerActions.applyCustomersFilters, (state: State, {filters}): State => {
      const newFilters = {...state.customerFilters};
      filters.forEach(({key, value}) => {
        newFilters[key as string] = value;
      });
      newFilters.offset = 0;
      return {...state, customerFilters: newFilters};
    })
  )
});

export const {
  name,
  reducer,
  selectCustomersState,
  selectCustomerItems,
  selectCustomerItemsPaginated,
  selectCustomerFilters,
  selectCustomerPaginationInfo
} = customersFeature;
